module.exports = __webpack_public_path__ + "static/media/live-chat1.2316b303.png";